import { createContext, useContext } from 'react'

import type { AuthResponse } from '../api/auth.api'
import type { SessionUser } from './session-store'

export interface AuthContextValue {
  user: SessionUser | null
  isAuthenticated: boolean
  /** Store tokens + session user after a successful login. */
  signIn: (auth: AuthResponse) => void
  /** Persists a username change without touching the rest of the session. */
  updateUsername: (username: string) => void
  /** Revoke the session server-side (best effort) and clear local state. */
  signOut: () => void
}

export const AuthContext = createContext<AuthContextValue | null>(null)

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext)
  if (!context) throw new Error('useAuth must be used within an AuthProvider')
  return context
}
